// extracted by mini-css-extract-plugin
export var root = "Logo-module--root--5zzsC";
export var white = "Logo-module--white--mio6G";
export var dark = "Logo-module--dark--KJDhy";